import { AccountAssetAllocation, AssetAllocationCategory } from '@/cip/_openapi/portfolio-optimizer';
import { getAssetAllocationCategoryLabel } from 'utils/asset-allocation-utils';

export { getAssetAllocationCategoryLabel };

export interface AssetClassExposureSlice {
    category: AssetAllocationCategory;
    label: string;
    exposure: number;
}

/**
 * Maps the pre-summed API response (one entry per category) to typed
 * AssetClassExposureSlice objects, sorted by descending exposure.
 */
export const mapToExposureSlices = (allocations: AccountAssetAllocation[]): AssetClassExposureSlice[] =>
    allocations
        .filter((item) => (item.exposure ?? 0) > 0)
        .map((item) => ({
            category: item.category,
            label: getAssetAllocationCategoryLabel(item.category),
            exposure: item.exposure ?? 0,
        }))
        .sort((a, b) => b.exposure - a.exposure);
